import { fetchApi } from "../../../../lib/fetchApi";
import { apiService } from "../../../../services/api/apiService";
import { Pagination, PaginationFilterDto } from "../../../../types/Pagination";
import { IPsListItemDto, IPsListNewItemDto } from "../types";

const BASE_URL = "/securityAllowedIpRule";

export const getSecurityIPS = async (body: PaginationFilterDto): Promise<Pagination<IPsListItemDto>> => 
    await apiService.post<PaginationFilterDto, Pagination<IPsListItemDto>>(`${BASE_URL}/search`, body)
  
export const deleteSecurityIPS = async (ipId: number): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/delete/${ipId}`);
};

export const activeSecurityIPS = async (ipId: number): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/active/${ipId}`);
};

export const getSecurityIPById = async (ipId: string): Promise<IPsListNewItemDto> => {
    const response = await fetchApi.get(`${BASE_URL}/detail/${ipId}`) as IPsListNewItemDto;
    return response
};

export const saveSecurityIP = async (body: IPsListNewItemDto): Promise<void> => {
    await fetchApi.post(`${BASE_URL}/save`, body);
};

export const editSecurityIPS = async (ipId: number, body: IPsListNewItemDto): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/edit/${ipId}`,body);
};
